/*
 * COPYRIGHT (c) 2022
 * HONEYWELL INC.,
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { memo, useContext, useState } from 'react';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../../../locales/en-US/descriptors';
import { Button } from '@scuf/common';
import ChartWidget from '../../../shared/Chart/ChartWidget';
import {
  convertDataForCarbonSavingsMeter,
  graphCarbon
} from '../../../shared/Utils/Utils';
import { ICarbonData } from '../../IEnergyManagementProps';
import { ApiContext } from '../../../../context/ApiContext';
import { IGrapghData } from '../../../shared/Chart/IChartWidgetProps';
import { actualWithColor } from '../../UtilityCostGraphWidget/UtilityLineGraphComponent/UtilityLineGraphComponent';
interface ICarbonComponentProps {
  data: ICarbonData;
  toggleFeatureScopeOne: boolean | undefined;
}

export const CarbonGraphComponent = (props: ICarbonComponentProps) => {
  const [t, lng] = useTranslation();
  const d = descriptors.energyManagement;
  const { data } = props;

  const apiContext = useContext(ApiContext);
  const { onCarbonViewDetailsClick } = apiContext;

  const onViewDetailsClick = () => {
    if (onCarbonViewDetailsClick) {
      onCarbonViewDetailsClick();
    }
  };

  const {
    emissionMeasurementUnit,
    monthWiseAggregations,
    emissionsByUtility,
    emissionsByScope
  } = data;
  const consumptionMeterData = props.toggleFeatureScopeOne
    ? convertDataForCarbonSavingsMeter(
        emissionsByScope,
        emissionMeasurementUnit,
        props.toggleFeatureScopeOne
      )
    : convertDataForCarbonSavingsMeter(
        emissionsByUtility,
        emissionMeasurementUnit
        // props.toggleFeatureScopeOne
      );
  const { displayUnit } = consumptionMeterData;

  const graphData = graphCarbon(
    monthWiseAggregations,
    emissionMeasurementUnit,
    displayUnit,
    undefined,
    lng
  );

  const { YearIndex, MonthIndex } = graphData;

  let { 0: first, [MonthIndex.length - 1]: last } = MonthIndex;
  let { 0: previousyear, [YearIndex.length - 1]: currentyear } = YearIndex;
  const actualColorUpdateIngraphData = actualWithColor(graphData);
  return (
    <div className="kpi-card-flex-container">
      <div className="kpi-card-monthwise-container">
        {previousyear != currentyear ? (
          <div className="kpi-card-monthwise-date-range energyGraph">
            {t(d.CARBONKPIDETAILS)} {first} {previousyear} - {last}{' '}
            {currentyear}
          </div>
        ) : (
          <div className="kpi-card-monthwise-date-range energyGraph">
            {t(d.CARBONKPIDETAILS)} {first} - {last} {currentyear}
          </div>
        )}
        <ChartWidget
          graphData={actualColorUpdateIngraphData as IGrapghData}
          unit={displayUnit}
          height="120px"
          axisUnitType="consumption"
          removePadding={true}
          tickIntervalEnable={true}
          renderedInHugUI={true}
          renderedFromCarbon={true}
        />
        <div className="kpi-card-view-details New-siteDashboard">
          <Button
            type="link"
            content={t(d.VIEWDETAILS)}
            className="view-details-button"
            onClick={() => onViewDetailsClick()}
          />
        </div>
      </div>
    </div>
  );
};
export default memo(CarbonGraphComponent);
